import { render } from "./IndividualData.vue?vue&type=template&id=d297e09c&scoped=true"
import script from "./IndividualData.vue?vue&type=script&lang=js"
export * from "./IndividualData.vue?vue&type=script&lang=js"

import "./IndividualData.vue?vue&type=style&index=0&id=d297e09c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d297e09c"]])

export default __exports__